export default __webpack_public_path__ + "static/media/feeslogo.a0750c30.svg";